// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_g2-6";
export var emphasizeQuantity = "_g2-3";
export var flatBottomCorners = "_g2-5";
export var productImage = "_g2-0";
export var quantityContainer = "_g2-2";
export var tooltip = "_g2-1";
export var wrapAndEllipsesOverflow = "_g2-4";